let GLOBAL = require('./globals');

const PlanData = {
    async list() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/plans`);
        return  await response.json();
    },
};

export default PlanData;



// WEBPACK FOOTER //
// ./src/data/PlanData.js